export type Environment = 'dev' | 'prod' | 'local'

const KNOWN: readonly Environment[] = ['dev', 'prod', 'local']

const raw = import.meta.env.VITE_ENVIRONMENT as Environment | undefined

// Falls back to 'local' on anything unrecognised rather than rendering an undefined
// ribbon colour. 'test' used to be in this union and was never set: the pipeline passes
// $(envLower), which is only ever dev or prod, and local is set by hand.
export const environment: Environment =
  raw && KNOWN.includes(raw) ? raw : 'local'

export const environmentLabel = environment.toUpperCase()

// Brand tokens, not CoreUI colour names. The ribbon has to keep meaning something once
// the theme layer repaints everything around it, and the environments do not map onto
// CoreUI's palette anyway - there is no "muted" button colour.
//
// Deliberately not the accent for local: --sl-accent now paints every button on the page,
// so a ribbon in it reads as furniture rather than as a signal.
const colorMap: Record<Environment, string> = {
  local: 'var(--sl-muted)', // your machine, nothing at stake
  dev: 'var(--sl-warning)', // amber: real deployment, not real data
  prod: 'var(--sl-negative)', // red: this is real
}

export const environmentColor: string = colorMap[environment]
